import { defaultMultiSubmissionConfig } from './competition_default';
import { competition7MultiSubmissionConfig } from './competition_7';
import { competition14MultiSubmissionConfig } from './competition_14';
import { competition18MultiSubmissionConfig } from './competition_18';
import { MultiSubmissionConfig } from '../types';

const COMPETITION_CONFIGS: Record<number, MultiSubmissionConfig> = {
  // Add per-competition modal definitions here as needed.
  7: competition7MultiSubmissionConfig,
  14: competition14MultiSubmissionConfig,
  18: competition18MultiSubmissionConfig,
};

export function getMultiSubmissionConfig(competitionId: number): MultiSubmissionConfig {
  const normalizedId = Number(competitionId);
  if (Number.isFinite(normalizedId) && COMPETITION_CONFIGS[normalizedId]) {
    return COMPETITION_CONFIGS[normalizedId];
  }
  return defaultMultiSubmissionConfig;
}
